// Empirical (2026-07-23): a lossless ÷4 preview of a 512² .202 slice needs
// ~17–19 KB of codestream; the DICOM header is ~2 KB. ~0.1 B/full-pixel with
// margin covers all measured slices; MIN_PREFIX floors tiny matrices.
const HEADER_BYTES = 4096;
const PREVIEW_BYTES_PER_PIXEL = 0.1;
const MIN_PREFIX = 24_576;

export const PREVIEW_DECODE_LEVEL = 2; // ÷4 (512→128)

export function computePrefixBytes(rows: number, cols: number): number {
  const est = HEADER_BYTES + Math.ceil(rows * cols * PREVIEW_BYTES_PER_PIXEL);
  return Math.max(MIN_PREFIX, est);
}

export function isProgressiveEnabled(): boolean {
  if (typeof window === "undefined") return false;
  // This experimental decoder path is useful for local measurement but has not
  // completed production validation. A query parameter must never enable it in
  // a deployed build (#881).
  return (
    import.meta.env.DEV && new URLSearchParams(window.location.search).get("progressive") === "1"
  );
}
